import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router';
import CustomerService from 'services/customer';
import _ from 'lodash';

const service = new CustomerService();

const useList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({ info: '' });
  const [clickPhone, setClickPhone] = useState('');
  const [showCustomerInfo, setShowCustomerInfo] = useState(false);
  const [showAddCustomer, setShowAddCustomer] = useState(false);

  useEffect(() => {
    delaySearch(filter);
  }, [filter]);

  const loadData = async (filterParams) => {
    const lst = await service.list(filterParams);
    setData(lst);
  };

  const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

  const onSearch = () => {
    delaySearch({});
  };

  const setFilterValue = (name, value) => {
    const newFilter = { ...filter };
    newFilter[name] = value;
    setFilter(newFilter);
  };

  const updateStats = async (id) => {
    await service.updateStats(id);
    loadData(filter);
  };

  const showCustomer = (phone) => {
    setClickPhone(phone);
    setShowCustomerInfo(true);
  };

  const refreshList = async () => {
    await loadData(filter);
  };

  const onNavigateOrder = (orderId) => {
    navigate(`/order/${orderId}`);
  };

  const onAddCustomer = () => {
    setShowAddCustomer(true);
  };

  const onCloseCustomerInfo = () => {
    setShowCustomerInfo(false);
  };

  const onCloseAddCustomer = () => {
    setShowAddCustomer(false);
  };

  return {
    data,
    filter,
    clickPhone,
    showCustomerInfo,
    showAddCustomer,
    setFilterValue,
    onSearch,
    showCustomer,
    refreshList,
    onNavigateOrder,
    onAddCustomer,
    onCloseCustomerInfo,
    onCloseAddCustomer,
    updateStats,
  };
};

export default useList;
